import { render, staticRenderFns } from "./TenantEditBookables.vue?vue&type=template&id=a104fce4&"
import script from "./TenantEditBookables.vue?vue&type=script&lang=js&"
export * from "./TenantEditBookables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports